import type { FaireProductEntity } from "../../entity_types/product";

export const p_b9qnxyd9az: FaireProductEntity = {
  token: "p_b9qnxyd9az",
  type: "product",
  name: "Pencil Flat Note Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/76a94ecfc369ae5f925ca60442bc6bf4cadf93f064297e63663d5f6a25ac4e46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2892d86b576f933773165b614acfabf04f550518ce3a7e4483329b518d088366.jpeg",
    "https://cdn.faire.com/fastly/755a7785ebc86d326f89f0570eebe64943c634978cb70b1de0289383bbd607b2.jpeg",
  ],
  priceDollars: 8,
  description:
    'A flat note is concise and smart. Not ostentatious, but clever. And without too much room, you can get right to the point, or be "well-edited" as we like to say.\n\nThis set includes 8 envelopes and 8 beautifully illustrated notecards, each with an extra illustration on the back.',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:42.016Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
